<template>
	<div class="header">
		<div class="container">
			<div class="flex">
				<div class="logo">
					<div class="logo_bg">
						<div class="left">
							<img src="../assets/index/logo.png" alt="logo" class="img" />
						</div>
						<div class="right">
							<div class="cn">中华角膜塑形镜学会</div>
							<div class="en">CHINESE SOCIETY OF ORTHOKERATOLOGY</div>
						</div>
					</div>
				</div>
				<div class="top-right m-100">
					<div class="topbar m-hide">
						<span>
							<a></a>
							<a></a>
						</span>
						<a></a>
						<a class="setup"></a>
					</div>
					<div class="yw"></div>
					<div class="stips">
						<form class="topSearch m-100" style="max-width: 100%;">
							<input v-model="searchText" @keydown.enter="search()" type="text" placeholder="请输入您要搜索的内容" />
							<button></button>
						</form>
						<!-- <div class="cnen">
							<a class="cn"></a>
							<a class="en"></a>
						</div> -->
					</div>
				</div>
			</div>
			<ul class="nav" style="display: flex; flex-wrap: wrap;">
				<li>
					<a style="cursor: pointer;" @click="toPage('/')">首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</a>
				</li>
				<li class="pulldown" v-for="(item, index) in menuList" :key="index" v-if = "item.id !=32 ">
					<a @mouseover="topHover = index" @click="toPage('/news_list?category=' + item.id)" class="butn" >{{ item.name }}</a>
					<ul v-if="topHover == index && item.children != null" @mouseleave="topHover = -1" class="pulldown-menu">
						<li v-for="(item2, index2) in item.children" :key="index2" >
							<a @click="toPage('/news_list')" :title="item2.name">{{ item2.name }}</a>
						</li>
					</ul>
				</li>
				<li class="pulldown" v-for="(item, index) in menuList" :key="index" v-if = "item.id ==32 ">
                	<a @mouseover="topHover = index" @click="toPage('/news_list?category=' + item.id)" class="butn" style="color: red;">{{ item.name }}</a>
                	<ul v-if="topHover == index && item.children != null" @mouseleave="topHover = -1" class="pulldown-menu">
                		<li v-for="(item2, index2) in item.children" :key="index2" >
                			<a @click="toPage('/news_list')" :title="item2.name">{{ item2.name }}</a>
                		</li>
                	</ul>
                </li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Header',
	data() {
		return {
			searchText: '',
			topHover: -1,
			menuList: []
		};
	},
	mounted() {
		this.getMenuList();
	},
	methods: {
		search() {
			if (this.searchText != '' && this.searchText != null && this.searchText != undefined) {
				this.toPage('/news_list?keywords=' + this.searchText);
			}
		},
		// 获取菜单列表
		getMenuList() {
			this.req({
				url: '/system/menus/list',
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.menuList = res.rows;
				}
			});
		},
		toPage(path) {
			if (path.split('=')[1] == '32') {
				this.$router.push('/query').catch(err => {
					// console.log('输出报错', err);
				});
			} else {
				this.$router.push(path).catch(err => {
					// console.log('输出报错', err);
				});
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/index/common.css"></style>
<style scoped src="../assets/index/header.css"></style>
<style scoped lang="scss">
.logo {
	.logo_bg {
		display: flex;
		.left {
			/* 对于宽度小于 768px 的设备 */
            @media (max-width: 767px) {
                img {
                    width: 50px;
              		height: 50px;
              		max-width: none;
               }
            }
            /* 对于宽度大于 768px 的设备 */
            @media (min-width: 768px) {
                img {
              		width: 100px;
              		height: 100px;
              		max-width: none;
              	}
            }

		}
		.right {
			display: flex;
			flex-direction: column;
			justify-content: center;
			color: #ffffff;
			margin: 0 0 0 10px;
			text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);

			/* 对于宽度小于 768px 的设备 */
            @media (max-width: 767px) {
                .cn {
                    font-size: 20px;
                    font-weight: bold;
                    letter-spacing: 8px;
                }
                .en {
                    font-size: 6px;
                    font-weight: lighter;
                    margin: 10px 0 0 0;
                    letter-spacing: 3.7px;
                }
            }
            /* 对于宽度大于 768px 的设备 */
            @media (min-width: 768px) {
                .cn {
                    font-size: 42px;
                    font-weight: bold;
                    letter-spacing: 8px;
                }
                .en {
                    font-weight: lighter;
                    margin: 10px 0 0 0;
                    letter-spacing: 3.7px;
                }
            }

		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue